<template>
    <div class="column-container d-flex order-lg-1 order-3 me-lg-auto">
        <OfferAmount :large-mobile-value="false" />
    </div>

    <div v-if="!isEmptyValue(offer.rep_apr.formatted)" class="column-container d-flex order-lg-2 order-4 me-lg-auto">
        <OfferComparisonRate />
    </div>

    <div
        v-if="!isEmptyValue(offer.apr_display.formatted)"
        class="column-container d-flex order-lg-3 order-5 me-lg-auto"
    >
        <GenericColumn :value="formatPercentage(offer.apr_display.formatted)" :label="$t('results.interestRate')" />
    </div>

    <div
        v-if="!isCreditOffer && !isEmptyValue(offer.monthly_repayment_display)"
        class="column-container d-flex order-lg-4 order-1 me-lg-auto"
    >
        <OfferMonthlyRepayment />
    </div>
</template>

<script>
import { formatPercentage } from '@js/utilities/number.js'

export default {
    inject: ['offer'],
    computed: {
        isCreditOffer: function () {
            return this.offer.type === 'line_of_credit' || this.offer.type === 'credit_card'
        },
    },
    methods: {
        formatPercentage: formatPercentage,
    },
}
</script>
